import { apiInstance } from 'src/services/api'

export const createdPasswordDefault = (cnpj: string): string => {
  const minutes = String(new Date().getMinutes()).padStart(2, '0')
  const seconds = String(new Date().getSeconds()).padStart(2, '0')

  const passwordDefault = `ls${cnpj.slice(0, 8)}${minutes}${seconds}`

  return passwordDefault
}

export const createdHashRememberPassword = async (
  email: string
): Promise<string> => {
  const user = {
    email: email,
  }

  const {
    data: { accessToken },
  } = await apiInstance(9008).post('/api/login', {
    login: 'consumoapi@londrisoft.com.br',
      password: process.env.REACT_APP_AUTHORIZATION_TOKEN_NUCLEO || "",
    })

  await apiInstance(8006).post('User/rememberPassword', user, {
    headers: {
      Authorization: process.env.REACT_APP_AUTHORIZATION_TOKEN_8006 || "",
    },
  })

  const {
    data: { tokenRememberPassword },
  } = await apiInstance(8006).get(`/User/Email/${email}`, {
    headers: {
      Authorization: process.env.REACT_APP_AUTHORIZATION_TOKEN_8006 || "",
    },
  })

  return tokenRememberPassword
}
